import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { Button } from './ui/Button';
const testimonials = [{
  text: <>
        Hermano, esto cambió mi vida sexual para siempre. Antes duraba 2-3
        minutos máximo y vivía con ansiedad constante. Ahora{' '}
        <strong className="text-white" data-id="element-254">
          controlo exactamente cuándo terminar
        </strong>{' '}
        y puedo durar{' '}
        <span className="bg-brand-gold/10 px-1 rounded text-brand-gold font-bold" data-id="element-255">
          25+ minutos
        </span>{' '}
        sin esfuerzo. Mi novia me dijo que nunca había sentido algo así. Me mira
        diferente ahora, con admiración real. Es increíble el poder y la
        confianza que sentís cuando sabés que dominás completamente la
        situación.
      </>,
  name: 'Martín R.',
  age: '28 años',
  profession: 'Ingeniero'
}, {
  text: <>
        No lo podía creer cuando empecé a ver resultados en 4 días. Pasé de
        acabar al toque a tener{' '}
        <strong className="text-brand-gold" data-id="element-256">control total</strong>. Ahora ella
        es la que no puede más y me ruega que no pare. Me siento como un rey en
        la cama. Mis amigos me preguntan qué me pasó porque cambió hasta mi
        actitud. Es que cuando sabés que sos bueno en algo tan importante, te
        cambia como hombre.
      </>,
  name: 'Diego M.',
  age: '32 años',
  profession: 'Comerciante'
}, {
  text: <>
        Pensé que era imposible para mí. Probé pastillas, cremas, ejercicios de
        Kegel... nada funcionaba. Este protocolo es completamente diferente,
        funciona desde adentro, desde la mente. Ahora tengo el control que
        siempre quise y ella no para de decirme lo{' '}
        <strong className="text-white" data-id="element-257">increíble que es estar conmigo</strong>.
        Por primera vez en mi vida me siento{' '}
        <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-258">
          seguro de mi performance sexual
        </span>
        .
      </>,
  name: 'Carlos L.',
  age: '26 años',
  profession: 'Contador'
}, {
  text: <>
        Lo que más me impactó es que no solo duré más, sino que empecé a{' '}
        <strong className="text-white" data-id="element-259">disfrutar realmente</strong>. Antes
        estaba tan concentrado en no acabar que no sentía nada. Ahora puedo
        relajarme, sentir todo y{' '}
        <strong className="text-brand-gold" data-id="element-260">
          decidir cuándo es el momento perfecto
        </strong>
        . Mi esposa dice que es como estar con un hombre completamente nuevo.
        Esto salvó mi matrimonio.
      </>,
  name: 'Fernando G.',
  age: '35 años',
  profession: 'Abogado'
}];
export function Testimonials() {
  return;
}